import { request } from '@/api/request'

export const me = async () => {
  const { data } = await request.get('/webapi/user/me')

  return data.value
}

export const changeName = async (newName: string) => {
  const { data } = await request.post(`/webapi/user/me/name/${newName}`);
  return data.value
}

export const checkName = async (newName: string) => {
  const { data } = await request.get(`/webapi/user/me/name/${newName}`);
  return data.value
}

export const checkEmail = async (newEmail: string) => {
  const { data } = await request.get(`/webapi/user/me/email/check/${newEmail}`);
  return data.value
}

export const requestChangeEmail = async (newEmail: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('email', newEmail);
  const { data } = await request.post(`/webapi/user/me/email/request_change`, bodyFormData);
  return data.value
}

export const verifyChangeEmail = async (token: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('token', token);
  const { data } = await request.post(`/webapi/user/me/email/verify_change`, bodyFormData);
  return data.value
}

export const verifyDeleteUser = async (token: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('token', token);
  const { data } = await request.post(`/webapi/user/me/apply_delete`, bodyFormData);
  return data.value
}

export const setCountry = async (country: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('country', country);
  const { data } = await request.post(`/webapi/user/me/set_country`, bodyFormData);
  return data.value
}